import { defineComponent as _defineComponent } from 'vue'
import { GET } from '@/admin-shared-modules/utils/ajax'
import { ref, watch } from 'vue'
import { store } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const edit = store.edit

const form = ref()
const rules = {
  icon: { required: true, message: '请填写' },
  ruleName: { required: true, message: '请填写' },
  url: { required: true, message: '请填写' }
}

async function onSubmit() {
  await form.value.validate()
  store.edit.onEditSubmit()
}

const labels = ref([])
async function fetchLabels() {
  try {
    const res = await GET('template_rule/labels', {})
    labels.value = res.data
  } catch (error) {}
}

watch(
  () => edit.visible,
  () => {
    if (edit.visible) {
      fetchLabels()
    }
  }
)

return { __sfc: true,edit, form, rules, onSubmit, labels, fetchLabels }
}

})